export function matcher(pattern) {
    if (pattern === "*") {
        return function (input) {
            return !!input;
        };
    }
    if (typeof pattern === "string") {
        return function (input) {
            return pattern === input.type;
        };
    }
    if (Array.isArray(pattern)) {
        return function (input) {
            return pattern.some((p) => matcher(p)(input));
        };
    }
    if (typeof pattern === "function" && Object.hasOwn(pattern, "toString")) {
        return function (input) {
            return pattern.toString() === input.type;
        };
    }
    if (typeof pattern === "function") {
        return function (input) {
            return pattern(input);
        };
    }
    throw new Error("invalid pattern");
}
//# sourceMappingURL=matcher.js.map